// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3J2Y8","inputWrap":"Table_inputWrap__1BE4b","col":"Table_col__20r7V","bmiTooltip":"Table_bmiTooltip__2MT2F"};